import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { ApiKey } from '../../../../types/api-keys';

type CellParams = ICellRendererParams<ApiKey> & {
  addCallback: () => void;
};

@Component({
  selector: 'app-pan-cell-apikey-header-actions',
  imports: [UiModule],
  templateUrl: './cell-apikey-header-actions.component.html',
  styleUrl: './cell-apikey-header-actions.component.scss',
})
export class CellApikeyHeaderActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
